<template>
  <div
    class="mt-1"
  >
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <span style="font-size:20px; color: #fff;">ตารางสรุปปริมาณรถในสายทางแต่ละจุด</span>
      </b-col>
      <b-col cols="12">
        <b-table
          responsive
          :per-page="perPage"
          :current-page="currentPage"
          :items="items"
          :fields="fields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template #cell(widscifi)="data">
            <div v-if="data.item.ISOnline === 'Online'">
              <b-link
                :to="{ path: `/traffic-sci-fi?wid=${data.item.wid}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <span>ดูเพิ่มเติม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
            </div>
            <div
              v-if="data.item.ISOnline === 'Offline'"
              :title="data.item.lastupdate"
            >
              <b-link
                :to="{ path: `/traffic-sci-fi?wid=${data.item.wid}`}"
                style="text-decoration: underline; color: #FF0000;"
              >
                <span>ดูเพิ่มเติม</span>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="24"
                />
              </b-link>
            </div>
          </template>

          <!-- <template #cell(wid)="data">
            <div v-if="data.item.ISOnline === 'Online'">
              <b-link
                :to="{ path: `/traffic-detail?wid=${data.item.wid}`}"
                style="text-decoration: underline; color: #11DF00;"
              >
                <b-img
                  :src="require('@/assets/images/icons/cartotal.svg')"
                  style="height: 30px; width: 30px; margin-top: -13px"
                />
              </b-link>
            </div>
            <div
              v-if="data.item.ISOnline === 'Offline'"
              :title="data.item.lastupdate"
            >
              <b-link
                :to="{ path: `/traffic-detail?wid=${data.item.wid}`}"
                style="text-decoration: underline; color: #FF0000;"
              >
                <b-img
                  :src="require('@/assets/images/icons/cartotal.svg')"
                  style="height: 30px; width: 30px; margin-top: -13px"
                />
              </b-link>
            </div>
          </template> -->
          <template #cell(Info)="data">
            <b-button
              v-b-modal="'modalProject'"
              title="กดเพื่อดูเพิ่มเติม"
              size="sm"
              variant="link"
              class="p-0"
              @click="$refs.pid2.InfoProject(data.item.wid)"
            >
              <feather-icon
                icon="InfoIcon"
                size="16"
                style="color: #11DF00;"
              />
            </b-button>
          </template>
          <!-- <template #cell(Traffic_Location)="data">
            {{ data.value }} จุด
          </template> -->
          <template #cell(traffic_light_connection_status)="data">
            <span
              v-if="data.value === 'connecting...'"
              style="color:yellow;"
            >{{ data.value }}</span>
            <span
              v-if="data.value === 'connected'"
              style="color:#11DF00;"
            >{{ data.value }}</span>
          </template>
          <template #cell(Total_Vehicle)="data">
            {{ data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }} คัน
          </template>
        </b-table>
      </b-col>
    </b-row>
    <modal-Project ref="pid2" />
  </div>
</template>

<script>
import {
  BRow, BCol, BTable, BLink, BButton,
} from 'bootstrap-vue'
import axios from '@axios'
import modalProject from '@/views/modal/modalProject.vue'

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BLink,
    BButton,
    modalProject,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      fields: [
        {
          key: 'detail',
          label: 'รายละเอียด',
          class: 'text-center',
        },
        {
          key: 'traffic_light_connection_status',
          label: 'สถานะ',
          class: 'text-center',
        },
        {
          key: 'traffic_light_controller_mode',
          label: 'โหมด',
          class: 'text-center',
        },
        {
          key: 'widscifi',
          label: 'รายละเอียด',
          class: 'text-center',
        },
        {
          key: 'Info',
          label: 'ข้อมูลโครงการ',
          class: 'text-center',
        },
      ],
      items: [],
      perPage: 25,
      pageOptions: [25, 50, 75, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      camconnect: [{
        Online: 'ออนไลน์', Offline: 'ออฟไลน์',
      },
      {
        Online: 'success', Offline: 'danger',
      }],
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // ทำ action ที่คุณต้องการเมื่อ path เปลี่ยน (แม้เป็น path เดิม)
      this.getMenuTraffic()
    },
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  mounted() {
    this.getMenuTraffic()
  },
  methods: {
    getMenuTraffic() {
      axios
        .post('/getMenuTrafficSub', { DeptID: this.$route.query.DeptID, username: this.userData.username })
        .then(response => {
          this.items = response.data
          this.totalRows = response.data.length
        })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
  .vue2leaflet-map {
    &.leaflet-container{
      position: absolute;
      width: 1454px;
      height: 568px;
    }
  }
</style>
